import { render, staticRenderFns } from "./addOrEditContractOld.vue?vue&type=template&id=38a9a660&"
import script from "./addOrEditContractOld.vue?vue&type=script&lang=js&"
export * from "./addOrEditContractOld.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditContractOld.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports